import React from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";

const EMPTY_VALUE = "Non renseigné";
const fullName = (user = {}) => [user.last_name, user.family_name, user.first_name].filter(Boolean).join(" ") || EMPTY_VALUE;

const formatAmount = (value, currency) => {
  const amount = Number(value);
  const formatted = Number.isFinite(amount) ? amount.toLocaleString("fr-FR", { maximumFractionDigits: 2 }) : "0";
  return `${formatted}${currency ? ` ${currency}` : ""}`;
};

const formatDate = (value) => {
  if (!value) return EMPTY_VALUE;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? EMPTY_VALUE : date.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
};

const DetailRow = ({ icon, label, value }) => (
  <div className="schoolfee-detail__row">
    <span><FeatherIcon icon={icon} size={15} />{label}</span>
    <strong>{value || EMPTY_VALUE}</strong>
  </div>
);

const ContactRow = ({ icon, value, href }) => (
  <div className="schoolfee-detail__contact">
    <span><FeatherIcon icon={icon} size={14} /></span>
    {href && value ? <a href={`${href}${value}`}>{value}</a> : <span>{value || EMPTY_VALUE}</span>}
  </div>
);

const PersonCard = ({ title, icon, person = {}, reference, badge }) => (
  <section className="schoolfee-detail__card schoolfee-detail__person">
    <header><span><FeatherIcon icon={icon} size={17} /></span><div><small>{badge}</small><h3>{title}</h3></div></header>
    <div className="schoolfee-detail__identity">
      <div className="schoolfee-detail__avatar">
        {person.avatar ? <img src={person.avatar} alt={`Portrait de ${fullName(person)}`} /> : <FeatherIcon icon="user" size={23} />}
      </div>
      <div><strong>{fullName(person)}</strong><small>{reference || "Aucune référence"}</small></div>
    </div>
    <div className="schoolfee-detail__contacts">
      <ContactRow icon="phone" value={person.tel || person.phone_number} href="tel:" />
      <ContactRow icon="mail" value={person.email} href="mailto:" />
      <ContactRow icon="map-pin" value={person.adress} />
    </div>
  </section>
);

const SchoolfeeDetail = ({ isModal, showModal, student: payment = {} }) => {
  const student = payment.user || {};
  const responsible = student.user || {};
  const staff = payment.staff?.user || {};
  const feeCategory = payment.sectionschoolfeecategory || {};
  const remaining = Number(payment.remaining_amount || 0);
  const currency = feeCategory.currency || "";
  const section = feeCategory.section?.entitled_section;
  const category = feeCategory.schoolfeecategory?.category || "Paiement scolaire";
  const trimester = payment.trimesectschool?.trimester;
  const studentReference = [payment.matricule, student.identity_number].filter(Boolean).join(" · ");
  const responsibleReference = [responsible.matricule, responsible.identity_number].filter(Boolean).join(" · ");
  const staffReference = [staff.matricule, staff.identity_number].filter(Boolean).join(" · ");

  return <Modal show={isModal} onHide={showModal} size="lg" centered backdrop="static" dialogClassName="schoolfee-detail" contentClassName="schoolfee-detail__content">
    <Modal.Header className="schoolfee-detail__header">
      <div className="schoolfee-detail__heading"><span><FeatherIcon icon="credit-card" size={20} /></span><div><small>Détail de l’opération</small><Modal.Title>{category}</Modal.Title></div></div>
      <button type="button" className="schoolfee-detail__close" onClick={showModal} aria-label="Fermer"><FeatherIcon icon="x" size={18} /></button>
    </Modal.Header>
    <Modal.Body className="schoolfee-detail__body">
      <section className="schoolfee-detail__summary">
        <div><small>Montant payé</small><strong>{formatAmount(payment.pay_mount, currency)}</strong><span><FeatherIcon icon="calendar" size={13} /> {formatDate(payment.createdAt)}</span></div>
        <span className={remaining > 0 ? "is-pending" : "is-paid"}><FeatherIcon icon={remaining > 0 ? "clock" : "check-circle"} size={15} />{remaining > 0 ? `Reste ${formatAmount(remaining, currency)}` : "Paiement soldé"}</span>
      </section>
      <div className="schoolfee-detail__grid">
        <section className="schoolfee-detail__card">
          <header><span><FeatherIcon icon="file-text" size={17} /></span><div><small>Transaction</small><h3>Informations du paiement</h3></div></header>
          <DetailRow icon="hash" label="Facture" value={payment.invoice} />
          <DetailRow icon="layers" label="Section" value={section} />
          <DetailRow icon="clock" label="Trimestre" value={trimester?.short_trimester || trimester?.trimester} />
          <DetailRow icon="calendar" label="Période" value={[payment.month?.month, payment.year?.year].filter(Boolean).join(" ")} />
        </section>
        <PersonCard title="Élève" badge="Bénéficiaire" icon="user" person={student} reference={studentReference} />
        <PersonCard title="Responsable de l’élève" badge="Contact familial" icon="users" person={responsible} reference={responsibleReference} />
        <PersonCard title="Personnel" badge="Paiement enregistré par" icon="briefcase" person={staff} reference={staffReference} />
      </div>
    </Modal.Body>
    <Modal.Footer className="schoolfee-detail__footer">
      <span><FeatherIcon icon="shield" size={14} /> Informations liées à cette transaction</span>
      <button type="button" onClick={showModal} className="btn btn-light schoolfee-detail__button"><FeatherIcon icon="x" size={15} /> Fermer</button>
    </Modal.Footer>
  </Modal>;
};

export default SchoolfeeDetail;
